
import React from "react";
import { Badge } from "@/components/ui/badge";
import { FileText, CheckCircle, Loader2 } from "lucide-react";

interface DocumentCount {
  requirementId: string;
  count: number;
  statuses: Record<string, number>;
}

interface DocumentIndicatorProps {
  documentCounts: DocumentCount[];
  requirementId: string;
  isLoading: boolean;
}

export function DocumentIndicator({ 
  documentCounts, 
  requirementId, 
  isLoading 
}: DocumentIndicatorProps) {
  if (isLoading) {
    return <Loader2 className="h-4 w-4 animate-spin" />;
  }

  const docInfo = documentCounts.find(d => d.requirementId === requirementId);
  
  if (!docInfo || docInfo.count === 0) {
    return null;
  }
  
  return (
    <div className="flex items-center space-x-2">
      <Badge 
        variant="outline" 
        className="flex items-center gap-1 bg-primary/5 cursor-pointer hover:bg-primary/10 transition-colors"
      >
        <FileText className="h-3 w-3" />
        <span>{docInfo.count}</span>
      </Badge>
      
      {docInfo.statuses.complete && (
        <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200 cursor-pointer hover:bg-green-100 transition-colors">
          <CheckCircle className="h-3 w-3 mr-1" />
          {docInfo.statuses.complete}
        </Badge>
      )}
      
      {docInfo.statuses.in_progress && (
        <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200 cursor-pointer hover:bg-blue-100 transition-colors">
          <Loader2 className="h-3 w-3 mr-1 animate-spin" />
          {docInfo.statuses.in_progress}
        </Badge>
      )}
    </div>
  );
}
